var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUploadInfo = function SvgIconUploadInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 2,
    height: 5,
    rx: 1,
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 2,
    height: 2,
    rx: 1,
    fillOpacity: 0.75
  }))));
};
export default SvgIconUploadInfo;